import { mergeClasses } from '#lib/helpers/class.js';

export function CoverPlaceholder({ width = 160, height = 100, className }) {

    return (
        <div
            className={mergeClasses(`overflow-hidden rounded bg-neutral-100 flex justify-center items-center`, className)}
            style={{
                width,
                height
            }}
        >
            <p className='text-neutral-600 font-semibold'>{_t.edit.fields.cover()}</p>
        </div>
    );
}
